import { insertInlineLatex } from '@blocksuite/affine-inline-latex';
import {
  getSelectedModelsCommand,
  getTextSelectionCommand,
} from '@blocksuite/affine-shared/commands';
import { type SlashMenuConfig } from '@blocksuite/affine-widget-slash-menu';
import { TeXIcon } from '@blocksuite/icons/lit';

import { insertLatexBlockCommand } from '../commands';
import { LatexTooltip } from './tooltips';

export const latexSlashMenuConfig: SlashMenuConfig = {
  items: [
    {
      name: '行内公式',
      group: '0_基础@8',
      description: '创建行内公式。',
      icon: TeXIcon(),
      tooltip: {
        figure: LatexTooltip('一个公式连接能量、质量与光。', 'E=mc^2', false),
        caption: '行内公式',
      },
      searchAlias: ['inlineMath, inlineEquation', 'inlineLatex'],
      action: ({ std }) => {
        std.command
          .chain()
          .pipe(getTextSelectionCommand)
          .pipe(insertInlineLatex)
          .run();
      },
    },
    {
      name: '公式',
      description: '创建公式块。',
      icon: TeXIcon(),
      tooltip: {
        figure: LatexTooltip(
          '使用 LaTeX 创建公式。',
          String.raw`\frac{a}{b} \pm \frac{c}{d} = \frac{ad \pm bc}{bd}`,
          true
        ),
        caption: '公式',
      },
      searchAlias: ['mathBlock, equationBlock', 'latexBlock'],
      group: '4_内容与媒体@10',
      action: ({ std }) => {
        std.command
          .chain()
          .pipe(getSelectedModelsCommand)
          .pipe(insertLatexBlockCommand, {
            place: 'after',
            removeEmptyLine: true,
          })
          .run();
      },
    },
  ],
};
